import React, { Component } from "react";
import NavigationChange from "../../components/NavigationChange";
import { Button, Form, Modal } from "react-bootstrap";
import Pagination from "@mui/material/Pagination";
import CreateBuildings from "./CreateBuildings";
import BuildingGrid from "./BuildingGrid";
import BuildingsApi from "../../api/BuildingsApi";
import AuthService from "../../session/AuthService";
import { Toaster, toast } from "react-hot-toast";
import ServiceRecordsModal from "../ServiceRecordPackage/ServiceRecordsModal";
import CreateServiceRecord from "../ServiceRecordPackage/CreateServiceRecord";
import EquipmentApi from "../../api/EquipmentApi";
import ManageUserService from "../../api/ManageUserService";

class BuildingContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buildingList: [],
      buildingCount: 0,
      totalPageNo: null,
      changeStateforEdit: false,
      changeStateforEditforCreateServiceRecord  : false ,
      editValue: {},
      pageNo: 0,
      search: "",
      currentPage: 1,
      activeServiceRecord: false,
      userList: [],
      totalresourceValue: {},
      resourseValue: 0,
      openListServiceRecord : false ,
      openplusIcon: false,
      commonArrays : []
     
    };
  }

  componentWillMount() {
    this.getBuildingList();
    this.togetEmployeeData();
    this.togetBuildingdata();
    toast.dismiss();
    console.log("authaservice" , AuthService.getUserTypeAdmin())
    console.log("authaservice" , typeof(AuthService.getUserTypeAdmin()))
  }


  togetBuildingdata = () => {
    let obj = {
      group_id: AuthService.getUserId(),
    };

    BuildingsApi.getBuildingData(obj).then((response) => {
      if (response.data && response.data.data) {
        this.setState({
          commonArrays: response.data.data.buildingData,
        });
      } else {
      }
    });
  };
 


  togetEmployeeData = () => {
    let obj = { group_id: parseInt(AuthService.getUserId()) };

    ManageUserService.getAllUserData(obj).then((response) => {
      console.log("response in userData", response);
      if (response.data && response.data.data) {
        this.setState({
          userList: response.data.data.UserData,
        });
      }
    });
  };

  getBuildingList = () => {
    let obj = {
      page: 0  ,
      search: "",
      group_id: parseInt(AuthService.getUserId()),
    };

    BuildingsApi.getBuildingList(obj).then((response) => {
      console.log("response", response);
      if (response.data && response.data.data) {
        this.setState(
          {
            buildingList: response.data.data.buildingList,
            buildingCount: response.data.data.totalCount,
            totalPageNo: response.data.data.totalPageno,
          }, () => {
            console.log("buildingList" , this.props.buildingList)
          });
      }
    });
  };

  render() {
    return (
      <>
        <div className="Heading" >
          <NavigationChange
            Topics={"Building"}
            numberofRecord={this.state.buildingCount}
            back={true}
            
          />
        </div>
       
        <div className="container-of-createButton" id="titleWithDropdowns">
        <div className="search-contain">
          
           
          <Form.Label style={{ fontSize: "17px" }}>Search</Form.Label>

          <div className="search">
            <span className="fa fa-search" onClick={this.search}></span>
            <input
              type="text"
              placeholder="Type Here..."
              name="search"
              value={this.state.search}
              onKeyPress={this.handleKeyPress}
              onChange={this.searchvalue}
              
            />
          </div>
        
        </div>
        {String(AuthService.getUserTypeAdmin()) !== "3" && (
           <div className="create-button">
           <div className="button-end">
             <button
               className="btn btn-success"
               onClick={this.OpenCreateTask}
               style={{
                 backgroundColor: "#8ABC49",
                 borderColor: "#8ABC49",
               
               }}
             >
               Add Building
             </button>
           </div>
         </div>
          )}
             
        </div>
        <BuildingGrid
          buildingList={this.state.buildingList}
          ActiveEdit={(a) => this.activeEdit(a)}
          onLoad={this.getBuildingList}
          editanddeleteload={this.editanddeleteload}
          getBuildingName={(a) => this.getBuildingName(a)}
          openCreateServiceRecord={(e) => this.openCreateServiceRecord(e)}
          openListServiceRecord={(e) => this.openListServiceRecord(e)}
        />
        
        <div className="mt-2" style={{ width: "100%", margin: "0 auto" }}>
          <div className="d-flex justify-content-center">
            <Pagination
              count={this.state.totalPageNo}
              onChange={(event, value) => this.handlePageChange(value)}
              page={this.state.currentPage}
            />
          </div>
        </div>

        {this.state.openModal && (
          <CreateBuildings
            handleClose={this.closeHandleclose}
            show={this.state.openModal}
            onLoad={this.getBuildingList}
            option={!this.state.changeStateforEdit ? "new" : "edit"}
            editValue={this.state.editValue}
            renderToast={(a)=>this.renderToast(a)}
            errorToast={(a) => this.errorToast(a)}
            editanddeleteload={this.editanddeleteload}
          />
        )}
        {this.state.activeServiceRecord && (
          <>
            <CreateServiceRecord
              show={this.state.activeServiceRecord}
              handleClose={this.closeCreateServiceRecord}
              option={!this.state.changeStateforEdit ? "new" : "edit"}
              userList={this.state.userList}
              comefrom={"Building"}
              Type={1}
              service_resourceId={this.state.resourseValue}
              renderToast={(e) => this.renderToast2(e)}
              editValue={this.state.editValue}
              openListofServiceRecord={(e)=>this.openListServiceRecordAgain(e)}
              commonArrays={this.state.commonArrays}
            />
          </>
        )}

        {this.state.openListServiceRecord && (
          <>
            <ServiceRecordsModal
              handleClose={this.closeListServiceRecord}
              show={this.state.openListServiceRecord}
              fulldata={this.state.resourcefullData}
              userList={this.props.userList}
              ActiveEdit={(a) => this.ActiveEdit2(a)}
              openExistingForm={(e) => this.openExistingForm(e)}
              openplusIcon={this.state.openplusIcon}
              closeopenPlusIcon={this.closeplusIcon}
              machineName={this.state.machineName}
              openDeleteFunction={(e) => this.openDeleteFunction(e)}
             
            />
          </>
        )}
           {this.state.opendeleteproductDialogue && this.deleteproductPopUp()}
        <Toaster />
      </>
    );
  }

  getBuildingName = (a) => {
    console.log("a in" , a)
    this.setState({
      machineName : a.building_name
    },() => {
      console.log("machineNAME" , this.state.machineName)
    })
  }

  openDeleteFunction =  (e) => {
    console.log(e , "delete ifd")
     this.setState({
       opendeleteproductDialogue : true,
       showfinalValue : e.servicerecord_Id,
       fulldata : e
     },() => {
       console.log("state values" , this.state.showfinalValue);
     })
 
   }


  openExistingForm = (e) => {
    this.setState({
      changeStateforEdit: false,
      activeServiceRecord: true,
      showOption: false,
      resourseValue: e.service_resourceId
    },() => {
      console.log("state value" , this.state)
    });
  };




  ActiveEdit2 = (a) => {
    this.setState({
      changeStateforEdit: true,
      editValue: a,
      
      activeServiceRecord : true
    });
  };

  closeListServiceRecord = () => {
    this.setState({
      openListServiceRecord : false 
    })
  }



  openListServiceRecordAgain = (e) => {


    console.log("e in openServiceRecordList" , e)

  
     console.log("open list of servicerecord", e);
     let obj = {
       service_type: 1,
       service_resourceId: e.service_resourceId,
     };
 
     EquipmentApi.togetFullDataByServiceTypeandResourceId(obj).then(
       (response) => {
         console.log(response, "response");
         if (response.data && response.data.message === "success") {
           if(response.data.data.length > 0 ){
             this.setState(
               {
                 resourcefullData: response.data.data,
                 openListServiceRecord: true,
                 openplusIcon: true,
                
               
               }
             );
            
           }else {
            this.getBuildingList();
           }
          
         }
       }
     );
   
   
 }

  openListServiceRecord = (e) => {


     console.log("e in openServiceRecordList" , e)

   
      console.log("open list of servicerecord", e);
      let obj = {
        service_type: 1,
        service_resourceId: e.building_id,
      };
  
      EquipmentApi.togetFullDataByServiceTypeandResourceId(obj).then(
        (response) => {
          console.log(response, "response");
          if (response.data && response.data.message === "success") {
            if(response.data.data.length > 0 ){
              this.setState(
                {
                  resourcefullData: response.data.data,
                  openListServiceRecord: true,
                  openplusIcon: true,
                  machineName : e.building_name
                 
                
                }
              );
          
            }else {
              this.getBuildingList();
            }
           
          }
        }
      );
    
    
  }

  closeplusIcon = () => {
    this.setState({
      openplusIcon: false,
    });
  };


  closeCreateServiceRecord = () => {
    this.setState({
      activeServiceRecord: false,
    });
  };

  openCreateServiceRecord = (e) => {
    console.log("e in createServiceRecord", e);
    this.setState({
      activeServiceRecord: true,
      resourseValue: e.building_id,
      totalresourceValue: e,
      changeStateforEdit: false
    });
  };







  searchvalue = (event) => {
    this.setState(
      {
        [event.target.name]: event.target.value,
      },
      () => {
       if(event.target.value.length === 0){
        this.search();
       }
      }
    );
  };

  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      this.search();
    }
  };

  search = () => {
    let obj = {
      page: 0,
      search: this.state.search,
      group_id: parseInt(AuthService.getUserId()),
    };

    BuildingsApi.getBuildingList(obj).then((response) => {
      console.log("response", response);
      if (response.data && response.data.data) {
        this.setState(
          {
            buildingList: response.data.data.buildingList,
            buildingCount: response.data.data.totalCount,
            totalPageNo: response.data.data.totalPageno,
          },
          () => {
            console.log("totalPageNo:", this.state.totalPageNo);
          }
        );
      }
    });
  };

  activeEdit = (a) => {
    this.setState({
      changeStateforEdit: true,
      editValue: a,
      openModal: true,
    });
  };

  OpenCreateTask = () => {
    this.setState({
      openModal: true,
      changeStateforEdit: false,
    });
  };

  closeHandleclose = () => {
    this.setState({
      openModal: false,
    });
  };

  handlePageChange = (i) => {
    let page = null;
    if (i === 1) {
      page = 0;
    } else {
      page = i - 1;
    }
    this.setState({ currentPage: i, pageNo: page }, () => {
      let obj = {
        page: this.state.pageNo,
        search: this.state.search,
        group_id: parseInt(AuthService.getUserId()),
      };
      BuildingsApi.getBuildingList(obj).then((response) => {
        if (response.data && response.data.data) {
          this.setState({
            buildingList: response.data.data.buildingList,
            buildingCount: response.data.data.totalCount,
            totalPageNo: response.data.data.totalPageno,
          });
        }
      });
    });
  };


  editanddeleteload = (i) => {
    let obj = {
      page: this.state.pageNo ,
      search: "",
      group_id: parseInt(AuthService.getUserId()),
    };

    BuildingsApi.getBuildingList(obj).then((response) => {
      console.log("response", response);
      if (response.data && response.data.data) {
        this.setState(
          {
            buildingList: response.data.data.buildingList,
            buildingCount: response.data.data.totalCount,
            totalPageNo: response.data.data.totalPageno,
          }
        );
      }
    });
  };


  renderToast2 = (status) => {
    toast.success(`Service Record  ${status} Successfully`);
    
  };

  renderToast = (status) => {
    toast.success(`Building ${status} Successfully`);
    
  };

  errorToast = (status) => {
    toast.error(`${status}`);
  }

  deleteproductPopUp = () => {
    return (
      <Modal show={true} size="md" centered onHide={this.deletehandleClose}>
        <Modal.Header closeButton className="CNSHeader">
          <h3 className="titleMd uppercase">Delete Service Record</h3>
        </Modal.Header>

        <Modal.Body className="">
          <div className="basicInfoWrapper newServiceFormWrapper">
            <Form.Group className="mb-3" controlId="formBasicName">
              <Form.Label>Are you sure to Delete this Service Record</Form.Label>
            </Form.Group>
          </div>
        </Modal.Body>
        <Modal.Footer className="CNSFooter">
          <Button variant="secondary" onClick={this.deletehandleClose}>
            Close
          </Button>
          <Button variant="success" type="button" onClick={this.deleteServiceRecord}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  deletehandleClose = () => {
    this.setState({
      opendeleteproductDialogue : false,
      openListServiceRecord: true
    })
  }


  deleteServiceRecord = () => {
    let obj = {
      servicerecord_Id: this.state.showfinalValue
    };

    EquipmentApi.deleteServiceRecord(obj).then((response) => {
      console.log("response : ", response);
      if (response.data && response.data.message === "success") {
         this.deletehandleClose();
        this.openListServiceRecordAgain(response.data.data);
      }
    });
  };


}
export default BuildingContainer;
